import {Action} from 'redux';

import {LaneActionTypes} from '../types';

export const LaneDumpActions = {
  success: (): Action => ({type: LaneActionTypes.dumpFetchSuccess}),
  fail: (): Action => ({type: LaneActionTypes.dumpFetchFail}),
  waiting: (): Action => ({type: LaneActionTypes.dumpFetchWaiting}),
};
